<template>
  <Teleport to="body">
    <div class="app-dialog-overlay z-[100] bg-slate-950/50" @click.self="close">
      <section ref="panel" role="dialog" aria-modal="true" :aria-label="title" tabindex="-1"
        class="app-dialog-panel w-full max-w-lg rounded-xl bg-white shadow-xl outline-none" @keydown="onKeydown">
        <header class="flex shrink-0 items-center justify-between gap-3 border-b px-5 py-3">
          <h2 class="text-lg font-semibold text-slate-800">{{ title }}</h2>
          <button type="button" aria-label="Cerrar" :disabled="busy" @click="close"
            class="h-11 w-11 shrink-0 rounded-lg text-slate-500 hover:bg-slate-100 disabled:opacity-50">✕</button>
        </header>
        <div class="app-dialog-body p-5"><slot /></div>
        <footer v-if="$slots.actions" class="shrink-0 flex flex-wrap justify-end gap-2 border-t px-5 py-3"><slot name="actions" /></footer>
      </section>
    </div>
  </Teleport>
</template>
<script>
import { onMounted, onUnmounted, ref } from 'vue';
export default {
  name: 'AppDialog',
  props: { title: { type: String, required: true }, busy: Boolean, focusFirst: Boolean },
  emits: ['close'],
  setup(props, { emit }) {
    const panel = ref(null), previousFocus = document.activeElement;
    let previousOverflow, previousInert;
    const close = () => { if (!props.busy) emit('close'); };
    const onKeydown = event => {
      if (event.key === 'Escape') { event.stopPropagation(); event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      const controls = [...panel.value.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]')]
        .filter(element => element.getClientRects().length);
      const first = controls[0], last = controls[controls.length - 1];
      if (!first) { event.preventDefault(); panel.value.focus(); }
      else if (event.shiftKey && [first, panel.value].includes(document.activeElement)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    onMounted(() => {
      previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
      const app = document.getElementById('app');
      if (app) { previousInert = app.inert; app.inert = true; }
      const focus = props.focusFirst ? panel.value.querySelector('input, select, textarea') : panel.value;
      (focus || panel.value).focus({ preventScroll: true });
    });
    onUnmounted(() => {
      document.body.style.overflow = previousOverflow;
      const app = document.getElementById('app'); if (app) app.inert = previousInert;
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    });
    return { panel, close, onKeydown };
  },
};
</script>
